import type { PendingDashboardData, PendingScope } from "../types";

const items: Array<{key: keyof PendingDashboardData; label: string; scope: PendingScope; alert?: boolean}> = [
  {key: "tomorrowsDeliveries", label: "Tomorrow’s Deliveries", scope: "tomorrow"},
  {key: "futureDeals", label: "Pending Future Deals", scope: "future"},
  {key: "callInsAwaitingApproval", label: "Call-Ins Awaiting Approval", scope: "call_ins"},
  {key: "approvedNotDelivered", label: "Approved — Not Delivered", scope: "approved"},
  {key: "depositsDue", label: "Deposits With Money Due", scope: "deposits_due"},
  {key: "followUpsDue", label: "Follow-Ups Due", scope: "followups_due"},
  {key: "closurePending", label: "Lost / Canceled Awaiting Sign-Off", scope: "closure_pending", alert: true}
];

export default function PendingSummaryCard({
  summary,
  canManage,
  onOpen,
  onAdd
}: {
  summary: PendingDashboardData;
  canManage: boolean;
  onOpen: (scope: PendingScope) => void;
  onAdd: () => void;
}) {
  return (
    <section className="panel pending-summary-panel">
      <div className="panel-heading pending-summary-heading">
        <div>
          <span className="eyebrow">Open opportunities</span>
          <h2>Pending Deals &amp; Deposits</h2>
        </div>
        <strong className="pending-total">{summary.totalOpen}</strong>
      </div>

      <div className="pending-summary-list">
        {items.map((item) => (
          <button
            type="button"
            key={item.key}
            className={item.alert && summary[item.key] > 0 ? "attention" : ""}
            onClick={() => onOpen(item.scope)}
          >
            <span>{item.label}</span>
            <strong>{summary[item.key]}</strong>
          </button>
        ))}
      </div>

      <div className="pending-summary-actions">
        <button className="secondary" type="button" onClick={() => onOpen("all_open")}>Open Tracker</button>
        {canManage && <button className="primary" type="button" onClick={onAdd}>Add Pending Deal</button>}
      </div>
    </section>
  );
}
